// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import styles from "./pageLoader.module.scss";

function PageLoader() {
    return (
        <div className={styles.wrapper} role="status" aria-live="polite">
            <span className={styles.spinner} />
            <span className={styles.srOnly}>Loading…</span>
        </div>
    );
}

export default PageLoader;
